<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="no-print">
            <v-row dense justify="center">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        @change="getStd()"
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="sem"
                        :items="semester_list"
                        item-text="display_name"
                        item-value="id"
                        label="Semester"
                        persistent-hint
                        hint="Please select semester"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="entrytype"
                        item-value="id"
                        :items="entrytype_list"
                        item-text="name"
                        label="Select Course Tpe"
                        outlined
                        persistent-hint
                        hint="Please select Course Tpe"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="
                            getDiv();
                        "
                        persistent-hint
                        hint="Please select standard"
                        @click="putnull"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="div"
                        item-value="div_id"
                        :items="div_list"
                        item-text="div_name"
                        label="Division"
                        outlined
                        persistent-hint
                        hint="Please select division"
                    />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="status"
                        :items="status_list"
                        item-text="name"
                        item-value="id"
                        label="Status"
                        outlined
                        persistent-hint
                        hint="Select Status"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && status">
                    <v-btn class="mt-6 button" @click="getClassFailAnalysisReportDetails()" :loading="fetch_loader"
                        >Fetch</v-btn
                    >
                </v-col>
            </v-row>
        </div>
        <v-row v-if="learner_fail_list!=''">
            <v-col cols="12" sm="12" md="12">
                <center>
                    <table dense width="1000px" class="elevation-1 table">
                        <thead>
                            <tr>
                                <!--   <th class="table" v-if="org_basic_data.trust_logo">
                                            <center>
                                                <img :src="org_basic_data.trust_logo" width="75%" alt="logo" />
                                            </center>
                                        </th> -->
                                <th class="table">
                                    <center>
                                        <center>
                                            <strong>
                                                <h4>
                                                    <span v-if="org_basic_data.trust_name"
                                                        >{{ org_basic_data.trust_name }}</span
                                                    >
                                                </h4>
                                            </strong>
                                            <strong>
                                                <h3>
                                                    <span v-if="org_basic_data.school_name"
                                                        >{{ org_basic_data.school_name }}</span
                                                    >
                                                </h3></strong
                                            >
                                            <strong>
                                                <h3>Class Wise Pass/Fail Analysis Report</h3>
                                            </strong>
                                        </center>
                                    </center>
                                </th>
                                <!-- <th class="table" v-if="org_basic_data.school_logo">
                                            <center>
                                                <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
                                            </center>
                                        </th> -->
                            </tr>
                            <tr>
                                <th class="table" colspan="3">
                                    <strong>
                                        <h4>Session : {{ sel_ay_data.ay }}</h4>
                                    </strong>
                                </th>
                            </tr>
                            <tr>
                                <th class="table" colspan="3">
                                    <strong>
                                        <h4>Semester : {{ semester }}</h4>
                                    </strong>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </center>
                 <div class="text-right mb-2">
                                    <v-btn small color="success" class="mr-2" @click="exportExcel">
                                        Export Excel
                                    </v-btn>

                                    <v-btn small color="primary" @click="printReport">
                                        Print
                                    </v-btn>
                                </div>
                <div id="my-table-id">
                    <v-simple-table dense class="elevation-1" fixed-header height="500px">
                        <thead>
                            <!-- <tr>
                                  <td :colspan="learner_fail_list.length + 3">
                                      <strong>{{ org_basic_data.school_name }}</strong>
                                  </td>
                              </tr>
                              <tr>
                                  <td :colspan="learner_fail_list.length + 3">
                                      <strong>{{ semester }} Result Analysis</strong>
                                  </td>
                              </tr> -->
                            <tr>
                                <th class="">Sr. No.</th>
                                <th class="">Class & Division</th>
                                <th class="">Strength</th>
                                <th class="">No Of Students Passed</th>
                                <th class="">No Of Students Passed With Gracing</th>
                                <th class="">No Of Students Failed</th>
                                <th class="">Pass Percentage (%)</th>
                                <th class="">Grace Percentage (%)</th>
                                <th class="">Fail Percentage (%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(l, index) in learner_fail_list" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ l.standard }} {{ l.division }}</td>
                                <td>{{ l.strength }}</td>
                                <td>{{ l.pass_cnt }}</td>
                                <td>{{ l.grace_cnt }}</td>
                                <td>{{ l.fail_cnt }}</td>
                                <td>{{ l.pass_percentage }} %</td>
                                <td>{{ l.grace_percentage }} %</td>
                                <td>{{ l.fail_percentage }} %</td>
                            </tr>
                            <tr>
                                <td colspan="2"><strong>Total</strong></td>
                                <td>{{ total_stud_cnt }}</td>
                                <td>{{ total_pass_cnt }}</td>
                                <td>{{ total_grace_cnt }}</td>
                                <td>{{ total_fail_cnt }}</td>
                                <td>{{ total_pass_percentage }} %</td>
                                <td>{{ total_grace_percentage }} %</td>
                                <td>{{ total_fail_percentage }} %</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    import * as XLSX from "xlsx";
    export default {
        data() {
            return {
                crs_id: null,
                crs_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                semester: null,
                fetch_loader: false,
                standard: null,
                division: null,
                show: false,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
                orgid: null,
                tenant: null,
                entrytype_list: [],
                entrytype: null,
                division_list: null,
                learner_fail_list: [],
                total_pass_cnt: [],
                total_fail_cnt: [],
                total_grace_cnt: [],
                total_stud_cnt: [],
                total_pass_percentage: [],
                total_fail_percentage: [],
                total_grace_percentage: [],
                org_basic_data: [],
                semester: null,
            };
        },

        methods: {
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = ["All"];
                //this.sel_std_data = "All";
                this.std_div_list = this.sel_ay_data.std_list;
                this.std_div_list.unshift("All");
                //this.sel_std_data = this.div_list[0];
            },
            getDiv() {
                if (this.sel_std_data == "All") {
                    this.div_list = ["All"];
                    this.div = "All";
                    this.div_list = this.division_list;
                    this.div_list.unshift("All");
                    this.div = this.div_list[0];
                    if (this.div_list.length == 0) {
                        alert("No division found!!!");
                        this.div_list = null;
                    }
                } else {
                    this.div_list = ["All"];
                    this.div = "All";
                    this.div_list = this.sel_std_data.div_list;
                    this.div_list.unshift("All");
                    this.div = this.div_list[0];
                    if (this.div_list.length == 0) {
                        alert("No division found!!!");
                        this.div_list = null;
                    }
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async getClassFailAnalysisReportDetails() {
                var std_id;
                if (this.sel_std_data == "All") {
                    std_id = this.sel_std_data;
                } else {
                    std_id = this.sel_std_data.std_id;
                }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: std_id,
                    sem: this.sem,
                    div: this.div,
                    status: this.status,
                    entrytype: this.entrytype,
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/Examination/getClassFailAnalysisReportDetails", data);
                    if (res.data.flag == "YES") {
                        this.learner_fail_list = res.data.learner_fail_list;
                        this.semester = res.data.semester;
                        this.total_pass_cnt = res.data.total_pass_cnt;
                        this.total_fail_cnt = res.data.total_fail_cnt;
                        this.total_grace_cnt = res.data.total_grace_cnt;
                        this.total_stud_cnt = res.data.total_stud_cnt;
                        this.org_basic_data = res.data.org_basic_data;
                        this.total_pass_percentage = res.data.total_pass_percentage;
                        this.total_fail_percentage = res.data.total_fail_percentage;
                        this.total_grace_percentage = res.data.total_grace_percentage;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.fetch_loader = false;
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                    this.fetch_loader = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.division_list = res.data.division_list;
                        this.semester_list = res.data.sem_list;
                        this.entrytype_list = ["All"];
                        this.entrytype_list = res.data.entrytype_list;
                        this.entrytype_list.unshift("All");
                        this.entrytype = this.entrytype_list[0];
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            exportExcel() {
                const data = this.learner_fail_list.map((l, index) => ({
                    "Sr No": index + 1,
                    "Class & Division": `${l.standard} ${l.division}`,
                    Strength: l.strength,
                    "Passed Students": l.pass_cnt,
                    "Passed With Grace": l.grace_cnt,
                    "Failed Students": l.fail_cnt,
                    "Pass Percentage": `${l.pass_percentage}%`,
                    "Grace Percentage": `${l.grace_percentage}%`,
                    "Fail Percentage": `${l.fail_percentage}%`,
                }));

                // Total Row
                data.push({
                    "Sr No": "",
                    "Class & Division": "TOTAL",
                    Strength: this.total_stud_cnt,
                    "Passed Students": this.total_pass_cnt,
                    "Passed With Grace": this.total_grace_cnt,
                    "Failed Students": this.total_fail_cnt,
                    "Pass Percentage": `${this.total_pass_percentage}%`,
                    "Grace Percentage": `${this.total_grace_percentage}%`,
                    "Fail Percentage": `${this.total_fail_percentage}%`,
                });

                const worksheet = XLSX.utils.json_to_sheet(data);

                const workbook = XLSX.utils.book_new();

                XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    "Pass_Fail_Analysis"
                );

                XLSX.writeFile(
                    workbook,
                    "Class_Wise_Pass_Fail_Analysis.xlsx"
                );
            },

            printReport() {
                const tableEl = document.querySelector("#my-table-id table");
                let printContents = tableEl ? tableEl.outerHTML : document.getElementById("my-table-id").innerHTML;

                let headerContent = `
                    <div style="text-align:center; margin-bottom:20px;">
                        <h2>${this.org_basic_data.school_name || ""}</h2>
                        <h3>Class Wise Pass/Fail Analysis Report</h3>
                        <h4>Session : ${this.sel_ay_data.ay}</h4>
                        <h4>Semester : ${this.semester}</h4>
                    </div>
                `;

                let printWindow = window.open("", "", "height=800,width=1200");

                printWindow.document.write(`
                <html>
                <head>
                    <title></title>
                    <style>
                        @page {
                            size: A4 landscape;
                            margin: 10mm;
                        }

                        html {
                            -webkit-print-color-adjust: exact;
                        }

                        body { font-family: Arial, sans-serif; padding: 20px; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid black; padding: 8px; text-align: center; font-size: 13px; }
                        h2, h3, h4 { margin: 5px; text-align: center; }
                        caption, .v-data-table__title, .v-data-table-header__content { display: none !important; }
                    </style>
                </head>
                <body>
                    ${headerContent}
                    ${printContents}
                </body>
                </html>
            `);

                printWindow.document.close();
                setTimeout(() => {
                    printWindow.print();
                    printWindow.close();
                }, 500);
            }
        },

        mounted() {
            this.onload();
            this.orgid = localStorage.getItem("EPS-org-id");
            this.awspath = localStorage.getItem("awspath");
            this.tenant = localStorage.getItem("EPS-tenant");
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }

    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }

    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }

        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }

    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    .table {
        border: none !important;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        .no-print {
            display: none !important;
        }

        table,
        td,
        tr {
            break-inside: avoid-page;
        }

        /*  img {
            width: 100% !important;
        }*/
        body,
        tr,
        th,
        td {
            font-size: 14pt !important;
            font-weight: bold !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        v-card {
            border: none !important;
        }

        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            /*size: 15.5in 15.5in;*/
            size: 16in 20in;
        }

        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }

    .table-container {
        max-height: 800px;
        overflow-y: auto;
        overflow-x: auto;
        border: 1px solid #ccc;
    }
</style>
